module.exports = __webpack_public_path__ + "img/gryhreg.216c6a45.png";